var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.message)?_c('div',{staticClass:"app-banner"},[_c('img',{attrs:{"src":require("@/assets/images/barricades/barricade-white.svg")}}),_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.message))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }